import React from "react";
import buzzed from "../images/buzzed.jpeg";

function ResultPage({ response, onGoogleClick }) {
  if (!response) return null;

  if (response.action === "GOOGLE") {
    return (
      <div className="container">
        <div className="card">
          <img src={buzzed} alt="restaurant" className="restaurant-image" />
          <h2 className="title">Thank you 🙏</h2>
          <p className="subtitle">
            We're happy you had a great experience today!
          </p>
          <button onClick={onGoogleClick} className="button button-google">
            ⭐ Leave a Google Review
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <img src={buzzed} alt="restaurant" className="restaurant-image" />
        <h2 className="title">Thank you 🙏</h2>
        <p className="subtitle">We appreciate your feedback!</p>
      </div>
    </div>
  );
}

export default ResultPage;